export default __webpack_public_path__ + "static/media/050.a25386f4.png";